import invariant from "tiny-invariant";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

interface LabelTitleProps {
  children: string;
  tooltipText?: string;
}

export function LabelTitle({ children, tooltipText }: LabelTitleProps) {
  invariant(typeof children === "string", "children must be a string");

  return (
    <div className="text-default flex items-center gap-x-0.5">
      <Typography.BodySm color="text-default" weight="font-semibold">
        {children}
      </Typography.BodySm>
      {tooltipText && (
        <TippyV2 content={tooltipText}>
          <Icon
            type="16-info"
            useWithStrokeCurrentColor
            size={16}
            className="size-3"
          />
        </TippyV2>
      )}
    </div>
  );
}
